import React from 'react';
import { useParams } from 'react-router-dom';
import Page from '../../components/Page';
import PasswordBox from '../../sections/employee/agreement/PasswordBox';
import { Box } from '@mui/material';
import DocumentSigningDueDateExceeded from '../../sections/employee/agreement/DocumentSigningDueDateExceeded';
import FormSent from '../../components/json-forms/FormSent';
import DocumentSign from '../../sections/employee/agreement/DocumentSign';
import DocumentSignOrder from '../../sections/employee/agreement/DocumentSignOrder';
import AgreementSent from '../../components/json-forms/AgreementSent';

export default function DocumentSigningPage() {
  const [isCodeValid, setIsCodeValid] = React.useState(false);
  const [isSigned, setIsSigned] = React.useState(false);
  const [signingDueDateExceeded, setSigningDueDateExceeded] = React.useState(false);
  const [signingDueDate, setSigningDueDate] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [payload, setPayload] = React.useState({}); // cały payload, głównie linki do płatności/kwestionariusza
  const { id, annex_nr, model } = useParams();

  if (isSigned) {
    const identifier = annex_nr == 0 ? 'umowa_zawarta' : 'aneks_zawarty';
    if (['umowa_zawarta', 'aneks_zawarty'].includes(identifier)) {
      return <AgreementSent identifier={identifier} data={payload} model={model} password={password} annexNr={annex_nr} />;
    }

    return <FormSent identifier={identifier} data={payload} model={model} />;
  }

  return (
    <Page title="Podpis dokumentu">
      {isCodeValid ? (
        <Box>
          {/* {!isSigned ? (
            <Form identifier="kwestionariusz" initData={{ id }} />
          ) : (
            <FormSent />
          )} */}
          {signingDueDateExceeded && model == 'Order'
            ? <DocumentSigningDueDateExceeded /> : model == 'Order'
              ? <DocumentSignOrder id={id} setIsSigned={setIsSigned} signingDueDate={signingDueDate} />
              : <DocumentSign id={id} setIsSigned={setIsSigned} signingDueDate={signingDueDate} />

          }
        </Box>
      ) : (
        <PasswordBox
          id={id}
          setIsCodeValid={setIsCodeValid}
          setIsSigned={setIsSigned}
          setSigningDueDateExceeded={setSigningDueDateExceeded}
          setSigningDueDate={setSigningDueDate}
          setPayload={setPayload}
          setParentCode={setPassword}
        />
      )}
    </Page>
  );
}
